import type { RootState } from 'state';
import type { RefundPromoCodesState } from '../slice';

function getRefundPromoCodes(state: RootState): RefundPromoCodesState['value'] {
  const { value } = state.dataService.refundPromoCodes.refundPromoCodes;
  return value;
}

export default getRefundPromoCodes;
